import { Typography } from "@mui/material";
import { useMemo } from "react";
import { useGetPatientRatingsQuery } from "src/api/services/patientRatingsApi";

interface Props {
  patientId: number;
}

const PatientRatings = ({ patientId }: Props) => {
  const { data = [] } = useGetPatientRatingsQuery({
    patient_id: patientId,
    status: "completed",
  });

  const ratingAverage = useMemo(() => {
    if (data.length === 0) {
      return "X/5";
    }

    const average =
      data.reduce((acc, rating) => acc + (rating.score ?? 0), 0) / data.length;

    return `${average.toFixed(1)}/5`;
  }, [data]);

  return (
    <Typography>
      <span style={{ fontWeight: 600 }}>Average patient experience score:</span>{" "}
      {ratingAverage}
    </Typography>
  );
};

export default PatientRatings;
